import { OperationExecutionTypesModel } from '../../../api/api';

export const getOperationMethodLabel = (type: OperationExecutionTypesModel): string => {
	switch (type) {
		case 'Read':
			return 'GET';
		case 'Create':
			return 'POST';
		case 'Update':
			return 'PUT';
		case 'Delete':
			return 'DELETE';
		case 'Execute':
			return 'EXECUTE';
		default:
			return 'POST';
	}
};

export const getOperationMethodChipColor = (type: OperationExecutionTypesModel): 'primary' | 'success' | 'warning' | 'error' | 'info' | 'default' => {
	switch (type) {
		case 'Read':
			return 'info';
		case 'Create':
			return 'success';
		case 'Update':
			return 'warning';
		case 'Delete':
			return 'error';
		case 'Execute':
			return 'primary';
		default:
			return 'default';
	}
};
